export default __webpack_public_path__ + "static/media/frame1.81ca4db5.png";